<template>
    <div class="container">
        <content-header :title="newsDetail.title"/>


        <article-detail-component :data="newsDetail"/>
<!--        <comment-form id="comment-form" :slug="newsDetail.slug" class="comment-wrapper"/>-->
    </div>
</template>

<script>
import ContentHeader from "../components/layout/ContentHeader";
import CommentForm from "../components/CommentForm";
import ArticleDetailComponent from "../components/ArticleDetailComponent";
import {mapActions, mapGetters} from "vuex";

export default {
    name: 'article-detail',
    components: {
        ContentHeader,
        CommentForm,
        ArticleDetailComponent
    },
    computed: {
        ...mapGetters(["newsDetail"])
    },
    methods: {
        ...mapActions(["fetchNewsDetail"])
    },
    watch: {
        $route: {
            deep: true,
            handler(newRoute, oldRoute) {
                if (newRoute.params.title !== oldRoute.params.title) {
                    this.$store.commit('setData', {key: 'newsDetail', value: {}, module: 'home'});
                    switch (newRoute.name) {
                        case 'offerDetail':
                            this.fetchNewsDetail({type: "offers", title: newRoute.params.title});
                            break;
                        case 'articleDetail':
                            this.fetchNewsDetail({type: "news", title: newRoute.params.title});
                            break;
                        case 'specialPrograms':
                            this.fetchNewsDetail({type: "specialPrograms", title: newRoute.params.title});
                            break;
                    }
                }
            }
        }
    },
    mounted() {
        this.$store.commit('setData', {key: 'newsDetail', value: {}, module: 'home'});
        switch (this.$route.name) {
            case 'offerDetail':
                this.fetchNewsDetail({type: "offers", title: this.$route.params.title});
                break;
            case 'articleDetail':
                this.fetchNewsDetail({type: "news", title: this.$route.params.title});
                break;
            case 'specialPrograms':
                this.fetchNewsDetail({type: "specialPrograms", title: this.$route.params.title});
                break;
        }
    }
}
</script>

<style lang="scss" scoped>
.article-detail {
    display: flex;
    margin-top: 30px;

    .comment_box {
        width: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-direction: column;

        .date {
            width: 100%;
            position: relative;
        }

        .date .value {
            background-color: #006688;
            color: #fff;
            padding: 10px 13px;
            font-size: 12px;
            width: 100%;

            @media screen and (max-width: 768px) {
                padding: 10px 10px;
            }
        }

        .comments_number {
            width: 100%;
            margin-top: 4px;
            background-color: #00b6cc;
            padding: 10px 12px;
            color: #fff;
            font-size: 12px;
        }

        .arrow_date {
            content: '';
            top: 0;
            right: -4px;
            display: inline;
            border-color: #006688 transparent;
            visibility: visible;
            position: absolute;
            border-style: solid;
            border-width: 5px 5px 0 0;
        }
    }


    &__content {
        margin-left: 20px;
        border-bottom: 1px solid #E0E0E0;
    }

    &__title {
        text-align: left;

    }

    @media screen and (max-width: 450px) {

        &__title {
            h2 {
                font-size: 18px;
            }

        }
    }

    &__image {
        width: 60%;

        img {
            width: 100%;
            margin: 5px 20px 20px 0;
        }
    }

    &__desc {

        p {
            text-align: left;
            font-size: 14px;
        }

        .more-detail {
            font-size: 14px;
            margin: 15px 0;
        }

        .routes {
            margin: 15px 0;
        }
    }
}

.comment-wrapper {
    margin-left: 120px;
    margin-top: 30px;
    padding: 10px;

    @media screen and (max-width: 570px) {
        margin-left: 0;
    }
}
</style>
